<template>
  <div class="login-page">
    <div
      class="login-card"
      :style="{
        backgroundImage: 'url(' + file[fileId] + ')',
        backgroundSize: 'contain',
      }"
      v-if="refreshDom"
    >
      <div class="login-card-content">
        <b-img
          class="login-card-logo"
          v-if="refreshDom"
          :src="file[fileId2]"
          v-bind="logoProps"
        />
        <div class="login-card-form">
          <div class="login-card-form-sub">
            <label class="login-card-form-label">{{ $t("Auth.number") }}</label>
            <input
              class="login-card-form-input"
              @focus="tabFocus0"
              v-model="userNumber"
              type="text"
              ref="number"
              :placeholder="$t('Auth.numberHolder')"
            />
          </div>
          <div class="login-card-form-sub">
            <label class="login-card-form-label">{{
              $t("Auth.password")
            }}</label>
            <input
              class="login-card-form-input"
              @focus="tabFocus1"
              v-model="password"
              type="password"
              ref="password"
              :placeholder="$t('Auth.passwordHolder')"
            />
          </div>
          <div class="login-card-form-forget">
            <button @click="forgetNumber" class="login-card-form-forget-button">
              {{ $t("Auth.forgetNumber") }}
            </button>
            <button
              @click="forgetPassword"
              class="login-card-form-forget-button"
            >
              {{ $t("Auth.forgetPassword") }}
            </button>
          </div>
          <button
            @keyup.enter="login"
            :disabled="engaging"
            class="login-card-form-button"
            @click="login"
            type="submit"
          >
            {{ loginStatus }}
          </button>
          <div class="recommendation-text">
            <span>{{ $t("Common.browserRecommendation") }}</span>
          </div>
        </div>
      </div>
    </div>

    <Footer class="login-footer"></Footer>
    <b-modal ok-only hide-header hide-backdrop id="login-wrong">
      {{ wrongInfo }}
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Footer from '@/components/Login/Footer'
import { mapState, mapGetters } from 'vuex'

const LoginCard = Vue.extend({
  name: 'LoginCard',
  data: function () {
    return {
      userNumber: '',
      password: '',
      loginStatus: this.$t('Auth.login'),
      logoProps: { blank: false, width: 115, height: 82, class: 'm1' },
      wrongInfo: '',
      focus: 1,
      refreshDom: true,
      fileId: 1001,
      fileId2: 1000
    }
  },
  components: {
    Footer
  },
  computed: {
    ...mapState({
      engaging: (state) => state.auth.loginEngaging,
      file: (state) => state.resource.file,
      status: (state) => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
  },
  watch: {
    engaging () {
      if (this.engaging) {
        this.loginStatus = this.$t('Auth.loging')
      } else {
        this.loginStatus = this.$t('Auth.login')
      }
    },
    isFileChange () {
      this.refresh()
    }
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.handleKeydown)
  },
  mounted () {
    window.addEventListener('keyup', this.handleKeydown)
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId)
    }
    if (!this.$store.state.resource.status[this.fileId2]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId2)
    }
    this.refresh()

    let windowHeight = window.innerHeight
    if (windowHeight > 1080) {
      document.getElementsByClassName('login-footer')[0].style.top =
        (windowHeight / 2 + 500).toString() + 'px'
    }
  },
  methods: {
    login: function () {
      if (this.userNumber.length < 10) {
        this.wrongInfo = this.$t('Auth.accountRequired')
        this.$bvModal.show('login-wrong')
      } else if (this.password.length < 1) {
        this.wrongInfo = this.$t('Auth.passwordRequired')
        this.$bvModal.show('login-wrong')
      } else {
        localStorage.userNumber = this.userNumber
        this.$store.dispatch('auth/userLoginWithNumber', {
          userNumber: this.userNumber,
          password: this.password
        })
      }
    },
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    },
    handleKeydown (e) {
      if (e.code === 'Enter') {
        this.login()
      } else if (e.code === 'Tab') {
        if (this.focus === 0) {
          this.$refs.number.focus()
          this.focus = 1
        } else {
          this.$refs.password.focus()
          this.focus = 0
        }
      }
    },
    tabFocus0 () {
      this.focus = 0
    },
    tabFocus1 () {
      this.focus = 1
    },
    forgetNumber () {
      this.$router.push({
        name: 'forgetNumber'
      })
    },
    forgetPassword () {
      this.$router.push({
        name: 'forgetPassword'
      })
    }
  }
})
export default LoginCard
</script>

<style>
.login-card {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1024px;
  height: 596px;
  /* background-image: url('../../assets/Login/card-left.png'); */
}
.login-card-content {
  position: relative;
  left: 530px;
  width: 460px;
}
.login-card-logo {
  position: relative;
  margin-top: 40px;
}
.login-card-form {
  position: relative;
  top: 20px;
}
.login-card-form-sub {
  margin: 20px 10px;
}
.login-card-form-label {
  position: relative;
  left: 0%;
  font-size: 20px;
  text-align: left;
  width: 460px;
}
.login-card-form-input {
  width: 380px;
  height: 50px;
  position: relative;
  left: 0px;
  transform: translateX(-30px);
  padding-left: 20px;
}
.login-card-form-button {
  width: 370px;
  height: 60px;
  background-image: url("../../assets/Login/3.png");
  border-radius: 30px;
  border: 0px none white;
  font-size: 20px;
  color: white;
  box-shadow: 0px 10px 5px #adf6e5;
  position: relative;
  transform: translateX(-30px);
  margin-top: 18px;
}
.login-card-form-forget-button {
  background: none;
  border: 0;
  margin-left: 20px;
  transform: translateX(45px);
  width: fit-content;
}
.login-footer {
  position: absolute;
  left: 50%;
  top: 92%;
  transform: translateX(-50%);
}

.recommendation-text {
  color: #000000;
  margin-top: 30px;
  margin-left: 15px;
  font-size: 16px;
  width: 370px;;
}
</style>
